import React from 'react';
import '../../../../styles/RouteCarousel.css';
import PropTypes from 'prop-types';

const RouteCarousel = ({ heading, iconUrl, viewMoreCta, customClass, children, moreRoutesUrl }) => {
  return (
    <div className={`rlCarousel ${customClass ? customClass : ''}`}>
      <div className="rlCarousel__left">{iconUrl && <div className={iconUrl} />}</div>
      <div className="rlCarousel__right">
        <div className="rlCarousel__top">
          {heading && <h4>{heading}</h4>}
          {viewMoreCta && (
            <a href={moreRoutesUrl} className="rlCarousel__viewmore">
              {viewMoreCta}
            </a>
          )}
        </div>
        <div className="rlCarouselCont">{children}</div>
      </div>
    </div>
  );
};

RouteCarousel.propTypes = {
  heading: PropTypes.string,
  iconUrl: PropTypes.string,
  viewMoreCta: PropTypes.string,
  customClass: PropTypes.string,
  children: PropTypes.any,
  moreRoutesUrl: PropTypes.string
};

export default RouteCarousel;
